<app-header extraClass="nav-down text-gray-innerMenu" displayNavigation="true"></app-header>


<section class="live-matches-wrp">

    <div class="banners-img mt-6">
        <div class="image">
            <img src="../assets/images/ipl/mobilebanner-1.jpg" alt="" class="w-100">
        </div>
    </div>
    <!--banners-img end-->

    <div class="offers-wrp uk-flex">
        <div class="card w-50">
            <h4><span>Upto 70% off</span></h4>
            <p>This cricket season play and win discounts on your favourite restaurants, 5- star hotels and many more brands.

            </p>
        </div>
        <div class="card w-50">
            <h4><span>Play for  free</span></h4>
            <p>This game is absolutely free to play! All you need to do is select a match and predict to win.

            </p>
        </div>
    </div>

    <!--How to play-->
    <div class="how-to-play">
        <div class="default-accordion">
            <mat-accordion multi="true">

                <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            How to play
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="panel-data">
                        <div class="play-card-wrp">
                            <div class="uk-flex card uk-flex-middle">
                                <div class="icon">
                                    <img src="./assets/images/ipl/1.svg" alt="" class="w-100 fitimg">
                                </div>
                                <div class="info">
                                    <h4>Step 1</h4>
                                    <p>Create an account and register to participate.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!--play-card-wrp end-->
                        <div class="play-card-wrp">
                            <div class="uk-flex card uk-flex-middle">
                                <div class="icon">
                                    <img src="./assets/images/ipl/2.svg" alt="" class="w-100 fitimg">
                                </div>
                                <div class="info">
                                    <h4>Step 2</h4>
                                    <p>Select your match and Agree or disagree with brand predictions of the day.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!--play-card-wrp end-->
                        <div class="play-card-wrp">
                            <div class="uk-flex card uk-flex-middle">
                                <div class="icon">
                                    <img src="./assets/images/ipl/3.svg" alt="" class="w-100 fitimg">
                                </div>
                                <div class="info">
                                    <h4>Step 3</h4>
                                    <p>On winning, buy the deal using the promo code to get Deal pe Deal.

                                    </p>
                                </div>
                            </div>
                        </div>
                        <!--play-card-wrp end-->
                    </div>
                </mat-expansion-panel>

                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            Game Rules
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="panel-data">
                        <ul class="game-rules">
                            <li>Sign in to the Things2do to play Deal Pe Deal from 08th March, 2022 to 29th May, 2022.</li>
                            <li>Play the game to win discounts and get Deal Pe Deal every day by supporting the brand predicting from the match
                            </li>
                            <li>Predictions will open 24 hours prior to the match time, and the polls will close 30 minutes before.
                            </li>
                            <li>You cannot update your predictions, once selected the prediction for that match will be locked.</li>
                            <li>For a single match, you can participate in multiple brand predictions.
                            </li>
                            <li>If you win, a discount code from the brand will be sent to you on your registered email address which will be valid for 24 hours. Alternatively, you can also check your profile.
                            </li>
                            <li>If you wish to avail Deal Pe Deal from the brand you selected, you need to apply the promotional discount code on checkout.
                            </li>
                        </ul>
                    </div>
                </mat-expansion-panel>

            </mat-accordion>
        </div>
    </div>


</section>


<div class="footer-small-wrp">
    <p>Powered by Things2do</p>
    <a href="">Terms and conditions.</a>
</div>

<div class="visibility-hidden"></div>
<div class="sticky-btn-wrp fixedme" (scroll)="onscroll()">

    <a (click)="redirectToPlay()" class="btn-more btn-fixed">
    Let’s play
  </a>

</div>